/* Mínimo 2 unidades para checkout — Dawn 15.4.1
   Subir como assets/cart-minimum.js */
(function () {
  const MIN_ITEMS = 2;
  let itemCount = null;

  function applyState() {
    if (itemCount === null) return;
    const blocked = itemCount > 0 && itemCount < MIN_ITEMS;

    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((btn) => {
      btn.toggleAttribute('disabled', blocked || itemCount === 0);
    });

    document.querySelectorAll('[data-cart-minimum-note]').forEach((note) => {
      note.hidden = !blocked;
    });

    document.querySelectorAll('[data-cart-minimum-dynamic]').forEach((el) => {
      el.hidden = blocked;
    });
  }

  function refresh() {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js')
      .then((r) => r.json())
      .then((cart) => {
        itemCount = cart.item_count;
        applyState();
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    refresh();

    // Re-verificar en cada cambio del carrito (agregar, quitar, cambiar cantidad)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(refresh, 0);
      });
    }
  });

  // Backstop: bloquea el submit del checkout aunque el botón se re-habilite
  // (Enter, devtools, HTML re-renderizado, etc.)
  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      const isCheckout = submitter && submitter.name === 'checkout';
      if (!isCheckout) return;

      if (itemCount !== null && itemCount > 0 && itemCount < MIN_ITEMS) {
        event.preventDefault();
        document.querySelectorAll('[data-cart-minimum-note]').forEach((n) => {
          n.hidden = false;
        });
      }
    },
    true
  );
})();
